<template>
  <div :class="$style.wrapper">
    <div :class="$style.inner" ref="inner">
      <div :class="$style.prev" v-if="current > 0" @click.stop="prev"></div>
      <div :class="$style.next" v-if="current < items.length - 1" @click.stop="next"></div>
      <div
        :class="[$style.item, current === index && $style.current]"
        v-for="(item, index) in items"
        :key="index"
        :style="{ backgroundImage: `url(${item})` }"
      ></div>
      <transition name="bounce">
        <v-btn v-if="current === items.length - 1" color="black" large @click="$emit('success')">Продолжить</v-btn>
      </transition>
      <div :class="$style.indicator">
        <div :class="$style.mover" :style="{ width: `${(100 / items.length) + 1}%`, transform: `translateX(${100 * current}%)translateZ(0)` }"></div>
        <div v-for="(item, index) in items" :key="index" @click="() => setCurrent(index)"></div>
      </div>
    </div>
  </div>
</template>
<script>
import interact from 'interactjs'

export default {
  name: 'comics',
  props: {
    items: Array,
  },
  data: () => ({
    current: 0,
  }),
  methods: {
    prev() {
      this.current -= 1
      if (this.current <= 0) {
        this.current = 0
      }
    },
    next() {
      this.current += 1
      if (this.current >= this.items.length) {
        this.current = this.items.length - 1
      }
    },
    setCurrent(current) {
      this.current = current
    },
  },
  mounted() {
    let x = 0

    interact(this.$refs.inner)
      .draggable({
        listeners: {
          move: (event) => {
            const { dx } = event
            x += dx
            event.stopPropagation()
          },
          end: () => {
            // treshold before slide
            if (Math.abs(x) < 100) {
              x = 0
              return
            }

            if (x > 0) {
              this.prev()
            } else {
              this.next()
            }
            x = 0
          },
        },
      })
  },
}
</script>
<style lang="scss" module>
.wrapper {
  width: 100%;
  height: 100%;
  background-color: #fff;
  background: url(./bg.jpg) no-repeat center;
  background-size: cover;
  position: relative;
  z-index: 9999998;
  transform: translateZ(0);
}

.inner {
  position: absolute;
  left: 5rem;
  right: 5rem;
  top: 50%;
  transform: translateY(-50%);
  //padding-top: 58.2%;
  //touch-action: none;
  max-height: 100%;
  height: 100%;

  button {
    position: absolute;
    right: 4rem;
    bottom: 4rem;
  }
}

.prev, .next {
  position: absolute;
  top: 50%;
  box-shadow: 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.25);
  background: #fff;
  border: 0.3rem solid #000;
  border-radius: 50%;
  width: 4.2rem;
  height: 4.2rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  transform: translateZ(0)translateY(-50%);
  z-index: 10;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: -20px;
    left: -20px;
    right: -20px;
    bottom: -20px;
  }

  &:hover {
    transform: translateZ(0)translateY(-50%)scale(0.95);
  }

  &:active {
    transform: translateZ(0)translateY(-50%)scale(0.9);
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 1.3rem;
    height: 2rem;
    background: url(./shevron.svg) no-repeat center;
    background-size: contain;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.prev {
  left: 2rem;

  &:before {
    left: 45%;
  }
}

.next {
  right: 2rem;

  &:before {
    left: 55%;
    transform: translate(-50%, -50%)rotate(180deg);
  }
}

.item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: opacity 0.4s ease;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0;
}

.current {
  opacity: 1;
}

.indicator {
  position: absolute;
  bottom: 4rem;
  width: 6rem;
  height: 1rem;
  display: flex;
  background: #FFFFFF;
  border-radius: 1rem;
  z-index: 100;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  overflow: hidden;

  & > div {
    flex: 1;
  }
}

.mover {
  position: absolute;
  top: 0;
  left: 0;
  flex: none;
  height: 105%;
  background: #000;
  border-radius: 1rem;
  transition: transform 0.3s ease;
  pointer-events: none;
}
</style>
